module.exports = __webpack_public_path__ + "img/infogram_logo.a69cf47f.jpg";